var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.887,
    height: 19.981,
    viewBox: "0 0 19.887 19.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1227.351,998h-14.376a2.7,2.7,0,0,0-2.756,2.664v14.653a2.674,2.674,0,0,0,2.636,2.665h7.188v-7.145h-1.8a.518.518,0,0,1-.479-.485v-2.3a.535.535,0,0,1,.479-.363h1.8v-2.18a3.639,3.639,0,0,1,3.834-4h1.916a.519.519,0,0,1,.48.484v1.938a.518.518,0,0,1-.48.484h-1.2c-1.2,0-1.437.606-1.437,1.454v1.816h2.755a.517.517,0,0,1,.479.484l-.239,2.3c0,.243-.24.364-.479.364h-2.4v7.145h4.193a2.673,2.673,0,0,0,2.635-2.665v-14.653A2.7,2.7,0,0,0,1227.351,998Z",
    transform: "translate(-1210.219 -998.004)",
    fill: "#840094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.8879ef21911c7a68abf08afcc6054e7e.svg";
export { ForwardRef as ReactComponent };